<template>
	<div class="budget">
		<div class="budgetIn">
      <el-row>
        <el-col :span="24">
          <div v-if="!itemType || !videoItemType" style="text-align: left;font-size: 12px">
            <div v-for="(item, index) in hintList" :key="index">
              <p v-html="item.tips" v-if="item.type === budgetForm.itemName"></p>
            </div>
          </div>
        </el-col>
      </el-row>
			<el-row type="flex" align="middle" justify="center" class="item">
				<el-col :span="8" class="alignLeft verify_item public_font">预算项目</el-col>
				<el-col :span="16" class="alignLeft">
					<el-select :disabled="editServiceStaff" v-model="budgetForm.itemName" placeholder="请选择" class="width280 public_font">
						<el-option v-for="(item,index) in budgetList" :key="index" :label="item.project" :value="item.project">
						</el-option>
					</el-select>
				</el-col>
			</el-row>
<!--			<el-row v-if="isVideo" type="flex" align="middle" class="item">-->
<!--				<el-col :span="8" class="alignLeft verify_item public_font">场次</el-col>-->
<!--				<el-col :span="16" class="alignLeft">-->
<!--					<el-input-number :min="0" :controls="false" v-model="budgetForm.meetingNum" placeholder="请输入内容" class="width280 public_font"></el-input-number>-->
<!--				</el-col>-->
<!--			</el-row>-->
<!--			<el-row v-if="isVideo" type="flex" align="middle" justify="center" class="item">-->
<!--				<el-col :span="8" class="alignLeft verify_item public_font">会议室类型</el-col>-->
<!--				<el-col :span="16" class="alignLeft">-->
<!--					<el-select v-model="budgetForm.mettingType" placeholder="请选择" class="width280 public_font">-->
<!--						<el-option v-for="(item,index) in meetingTypeList" :key="index" :label="item.mettingTypeDesc" :value="item.mettingTypeDesc">-->
<!--						</el-option>-->
<!--					</el-select>-->
<!--				</el-col>-->
<!--			</el-row>-->
<!--			<el-row v-if="itemType && !isVideo" type="flex" align="middle" class="item">-->
			<el-row v-if="itemType" type="flex" align="middle" class="item">
				<el-col :span="8" class="alignLeft verify_item public_font">预算金额</el-col>
				<el-col :span="16" class="alignLeft">
					<el-input-number :min="0" :controls="false" v-model="budgetForm.amount" placeholder="请输入内容" class="width280 public_font"></el-input-number>
				</el-col>
			</el-row>
			<el-row v-if="!itemType" type="flex" align="middle" justify="center" class="item">
				<el-col :span="8" class="alignLeft verify_item public_font">服务类型</el-col>
				<el-col :span="16" class="alignLeft">
					<el-select v-model="budgetForm.serviceType" placeholder="请选择" class="width280 public_font">
						<el-option v-for="(item,index) in serviceTypeList" :key="index" :label="item" :value="item">
						</el-option>
					</el-select>
				</el-col>
			</el-row>
			<el-row v-if="!itemType" type="flex" align="middle" class="item">
				<el-col :span="8" class="alignLeft verify_item public_font">人数</el-col>
				<el-col :span="16" class="alignLeft">
					<el-input-number :min="0" :controls="false" v-model="budgetForm.peopleNum" placeholder="请输入内容" class="width280 public_font"></el-input-number>
				</el-col>
			</el-row>
			<el-row v-if="!itemType && budgetForm.serviceType=='现场人员'" type="flex" align="middle" justify="center" class="item">
				<el-col :span="8" class="alignLeft verify_item public_font">开始日期</el-col>
				<el-col :span="16" class="alignLeft">
					<el-date-picker :picker-options="pickerOptions" value-format="yyyy-MM-dd" v-model="budgetForm.startDate" type="date" placeholder="选择日期" class="width280 public_font">
					</el-date-picker>
				</el-col>
			</el-row>
			<el-row v-if="!itemType && budgetForm.serviceType=='现场人员'" type="flex" align="middle" justify="center" class="item">
				<el-col :span="8" class="alignLeft verify_item public_font">结束日期</el-col>
				<el-col :span="16" class="alignLeft">
					<el-date-picker :picker-options="pickerOptions" value-format="yyyy-MM-dd" v-model="budgetForm.endDate" type="date" placeholder="选择日期" class="width280 public_font">
					</el-date-picker>
				</el-col>
			</el-row>
			<el-row v-if="!itemType" type="flex" align="middle" class="item">
				<el-col :span="8" class="alignLeft verify_item public_font">天数</el-col>
				<el-col :span="16" class="alignLeft">
					<el-input-number :min="0" :controls="false" :readonly="budgetForm.serviceType=='现场人员'" v-model="budgetForm.days" placeholder="请输入内容" class="width280 public_font"></el-input-number>
				</el-col>
			</el-row>
<!--			<el-row v-if="budgetForm.itemName != '讲课费' && !isVideo" type="flex" align="start" class="item">-->
			<el-row type="flex" align="start" class="item">
				<el-col :span="8" class="alignLeft public_font" :class="{'verify_item':budgetForm.itemName == '其他费用(现场垫付费用)'}">备注</el-col>
				<el-col :span="16" class="alignLeft">
					<el-input type="textarea" v-model="budgetForm.descr" placeholder="请输入内容" class="width280 public_font"></el-input>
				</el-col>
			</el-row>
			<el-row style="color: red;" type="flex" align="start" class="item" v-if="!itemType && budgetForm.serviceType && budgetForm.peopleNum && budgetForm.days">
				<el-col :span="16" class="alignLeft">
					<span>{{budgetForm.serviceType}}预算( </span>
					<span v-if="budgetForm.serviceType=='前期人员'">{{beforeCharge}}</span>
					<span v-if="budgetForm.serviceType=='现场人员'">{{middleCharge}}</span>
					<span v-if="budgetForm.peopleNum">* {{budgetForm.peopleNum}}</span>
					<span v-if="budgetForm.days"> * {{budgetForm.days}}</span> )
				</el-col>
				<el-col :span="8" class="alignLeft">
					<span>{{amountSum}}</span>
				</el-col>
			</el-row>
			<el-row class="footer">
				<el-button class="width100 falseBtn" @click.native="doAsync(false)">取消</el-button>
				<el-button class="width100 sureBtn" :loading="btnLoading" @click.native="doAsync(true)">确定</el-button>
			</el-row>
		</div>
	</div>
</template>

<script>
	import budgetEditor from '@scripts/components/budgetEditor.js';
	//	import { iStorage } from 'smart-core-util';
	export default {
		extends: budgetEditor,
		data() {
			return {
				doType: true,
				btnLoading: false, // 提交按钮状态
				addServiceStaff: false, //为了同app判断保持同步，针对上会服务费
				editServiceStaff: false, //编辑
				modelData: {},
				taskList: [],
				serviceTypeList: ["前期人员", "现场人员"],
				pickerOptions: {
					disabledDate(time) {
						//			        	return time.getTime() < Date.now();
					}
				},
				beforeCharge: "", //
				middleCharge: "", //
				beforeAmount: "",
				middleAmount: "",
				amountSum: "",
				hintList: [],
				meetingTypeList: []
			}
		},
		computed: {
			itemType() {
				if(this.budgetForm.itemName == "上会服务人员服务费" && this.eventSize != 'level2') {
					return false;
				} else {
					return true;
				}
			},
			isVideo() {
				return Object.is(this.budgetForm.itemName, "视频会议")
			},
      videoItemType() {
        if (this.budgetForm.itemName == "视频会议") {
          return false;
        } else {
          return true;
        }
      }
		},
		watch: {
			modelData: {
				handler: "listenModelData",
				deep: true
			},
      // 项目名称
      ["budgetForm.itemName"]() {
        this.modelData.addType != "edit" && this.modelData.taskList && this.modelData.taskList.forEach(item => {
          if (this.budgetForm.itemName == item.itemName && this.budgetForm.itemName != "上会服务人员服务费") {
            this.$message({
              message: '不能重复添加预算项目',
              type: 'error',
              duration: 500
            });
            this.budgetForm.itemName = ''
          }
        })
      },
			//现场人员开始日期
			["budgetForm.startDate"]() {
				this.verirfyEndDate();
			},
			//现场人员结束日期
			["budgetForm.endDate"]() {
				this.verirfyEndDate();
			},
			["budgetForm.serviceType"]() {
				this.getAmount();
			},
			["budgetForm.peopleNum"]() {
				this.getAmount();
			},
			["budgetForm.days"]() {
				this.getAmount();
			},
			// ["budgetForm.mettingType"]() {
			// 	this.getMeetingAmount();
			// },
			// ['budgetForm.meetingNum']() {
			// 	if(this.budgetForm.meetingNum > 99) {
			// 		this.budgetForm.meetingNum = 99;
			// 		this.$message.error("场次不得大于99");
			// 	} else if(this.budgetForm.meetingNum < 0) {
			// 		this.budgetForm.meetingNum = Math.abs(this.budgetForm.meetingNum);
			// 		this.$message.error("场次不能为负");
			// 	}
			// },
		},
		created() {
			// this.getMeetingType()
		},
		methods: {
			// async getMeetingType() {
			// 	let params = {
			// 		sourcetype: 1
			// 	}
			// 	let result = await this.api.get(this.url.meeting.mettingPriceQuery, {
			// 		params: params
			// 	})
			// 	if(result.success) {
			// 		this.meetingTypeList = result.content
      //     this.getMeetingAmount()
			// 	}
			// },
			verirfyEndDate() {
				if(
					new Date(this.budgetForm.endDate) < new Date(this.budgetForm.startDate)
				) {
					this.$message.error("结束时间不能小于开始时间");
					this.budgetForm.endDate = "";
				}
				if(this.budgetForm.startDate && this.budgetForm.endDate && this.budgetForm.serviceType == '现场人员') {
					let startDate = new Date(this.budgetForm.startDate).getTime();
					let endDate = new Date(this.budgetForm.endDate).getTime();
					let milliseconds = endDate - startDate;
					this.budgetForm.days = milliseconds / (24 * 60 * 60 * 1000) + 1;
				}
			},
			//日期必须在会议期间
			listenModelData() {
				switch(this.modelData.addType) {
					case 'add': //新增
						this.addServiceStaff = true;
						this.editServiceStaff = false;
						break;
					case 'edit': //编辑
						this.addServiceStaff = false;
						this.editServiceStaff = true;
						if(this.modelData.itemName != '上会服务人员服务费' || this.eventSize == 'level2') {
							this.budgetForm = {
								itemName: this.modelData.itemName, //预算项目
								amount: this.modelData.amount, //预算金额
								descr: this.modelData.descr, //备注
								mettingType: this.modelData.mettingType, //会议室类型
								meetingNum: this.modelData.meetingNum, //场次
							}
						} else if(this.modelData.itemName == '上会服务人员服务费' && this.eventSize != 'level2') {
							this.budgetForm = {
								index: this.modelData.index,
								itemName: "上会服务人员服务费", //预算项目
								serviceType: this.modelData.serviceType, //服务类型
								amount: this.modelData.amount, //预算金额
								descr: this.modelData.descr, //备注
								startDate: this.modelData.startDate,
								endDate: this.modelData.endDate,
								peopleNum: this.modelData.peopleNum, //人数
								days: this.modelData.days //天数
							}
							this.beforeCharge = this.formatMoney(this.modelData.beforeCharge); //前期人员单价
							this.middleCharge = this.formatMoney(this.modelData.middleCharge); //现场人员单价
						}
						break;
				}
				let dtStart = new Date((new Date(this.modelData.dtStart) / 1000 - 86400) * 1000);
				let dtEnd = new Date((new Date(this.modelData.dtEnd) / 1000 + 86400) * 1000);
				this.pickerOptions = {
					disabledDate(time) {
						return time.getTime() < new Date(dtStart) || time.getTime() > new Date(dtEnd);
					}
				}
			},
			getBudget() {
				this.modelData = this.iStorage.get('model');
				//获取会议id
				this.iStorage.set('proposalId', this.modelData.miceId);
				this.taskList = this.modelData.taskList;

				//遍历出 上会服务人员服务费，对添加和编辑有用！！！
				var serviceList = this.taskList.filter((ele) => {
					return ele.itemName == '上会服务人员服务费' || ele.name == '上会服务人员服务费'
				});
				this.serviceList = serviceList.length > 0 ? serviceList[0].itsExtData.peopoleExpense : [];
				this.iStorage.set('budgetItemList', this.taskList); //为了跟APP判断逻辑同步
				this.iStorage.set('serviceList', this.serviceList); //为了跟APP判断逻辑同步
				this.iStorage.set("budgetItem", this.modelData); //为了跟APP判断逻辑同步
			},
			async doAsync(type) {
				this.doType = type;
				if(this.doType) {
					if(this.budgetForm.itemName && this.budgetForm.itemName != '上会服务人员服务费' && (this.modelData.itemName != '上会服务人员服务费' || this.eventSize == 'level2')
            && !this.editServiceStaff && this.taskList.filter((ele) => {
							return ele.itemName == this.budgetForm.itemName
						}).length > 0) {
						this.$message({
              message: '不能重复添加预算项目',
              type: 'error',
              duration: 1000
            });
						return false;
					}
					this.budgetForm.amount += ''
					this.btnLoading = true
					await this.saveAsync({
						onSuccess: (response) => {
							console.log(response)
							this.$message({
								message: '保存成功',
								type: 'success'
							})
							this.btnLoading = false
							this.postMessage()
						},
						toast: null,
						$messageError: (error) => {
							this.$message.error(error)
						},
						type: 'web',
					});
					this.btnLoading = false
				} else {
					this.postMessage();
					return;
				}
			},
			postMessage() {
				let data = {
					from: "simulator",
					to: "budgetEditor",
					type: this.doType
				};
				window.parent.postMessage(data, "*");
			}
		}
	}
</script>

<style scoped>
	@import '../assets/css/public.css';
	.budget {
		width: 520px;
		margin: 0 auto;
		padding: 0 0 50px;
		color: #666666;
		font-size: 16px;
	}

	.budgetIn {
		padding: 0 50px;
	}

	.item {
		padding: 10px 0;
	}

	.footer {
		margin: 20px 0 0;
	}
</style>

<style>
	.public_font {
		color: #606266 !important;
		font-size: 14px !important;
		font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
	}

	.public_font .el-input__inner {
		color: #606266 !important;
		font-size: 14px !important;
		font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
	}

	.public_font .el-textarea__inner {
		color: #606266 !important;
		font-size: 14px !important;
		font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
	}

	.public_font .el-textarea__inner::-webkit-input-placeholder {
		color: #CCCCCC;
		font-size: 11px;
	}

	.public_font .el-textarea__inner:-moz-placeholder {
		color: #CCCCCC;
		font-size: 12px;
	}

	.public_font .el-textarea__inner::-moz-placeholder {
		color: #CCCCCC;
		font-size: 12px;
	}

	.public_font .el-textarea__inner:-ms-input-placeholder {
		color: #CCCCCC;
		font-size: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/components/budgetEditor.vue